// =============================================================================
// Caption clean-up applied to every generated caption.
//
// The long dash is the single most recognisable tell that a caption was
// written by a model. People read it as "this was not written by the shop",
// which is the opposite of what this product is for, so it is removed rather
// than discouraged.
//
// The prompt asks for it to be avoided and this removes any that survive. Both
// are needed: a prompt instruction is a strong tendency, not a guarantee, and
// one dash in one caption is enough to give the game away.
//
// Pure and dependency-free so it is unit-testable and runs on either side.
// =============================================================================
/** Em dash, en dash, horizontal bar, and the typed "--" that stands in for one. */
const LONG_DASH = /\s*(?:—|–|―|--)\s*/g;
/**
 * Replaces long dashes with punctuation a person would actually type.
 *
 * A dash between two numbers is a range ("9–5", "2024–2025") and becomes a
 * hyphen; everywhere else it is doing the job of a comma and becomes one. A
 * dash that opens a line is decoration and simply goes.
 */
export function stripLongDashes(text) {
    return (text
        // A range keeps its meaning only as a hyphen: "9, 5" is nonsense.
        .replace(/(\d)\s*(?:—|–|―|--)\s*(\d)/g, "$1-$2")
        // Opening a line: drop it rather than start a sentence with a comma.
        .replace(/(^|\n)\s*(?:—|–|―|--)\s*/g, "$1")
        .replace(LONG_DASH, ", ")
        // The dash often sat next to punctuation that now reads doubled.
        .replace(/([,.!?;:])\s*,\s*/g, "$1 ")
        .replace(/\s+,/g, ",")
        .replace(/,\s*,+/g, ",")
        // A trailing ", " from a dash at the very end is not a sentence.
        .replace(/,\s*$/g, "")
        .replace(/[ \t]{2,}/g, " ")
        .trimEnd());
}
/**
 * Everything applied to a caption before it is stored.
 *
 * Kept as one named function so the list of clean-ups has a single home and a
 * single place to test, rather than accumulating inline `.replace` calls at
 * each of the three call sites that generate captions.
 */
export function cleanCaption(text) {
    return stripLongDashes(text).trim();
}
//# sourceMappingURL=captions.js.map